const headers = [
  { label: "url*", key: "url" },
  { label: "list_name*", key: "listName" },
];

const data = [
  {
    url: "https://www.linkedin.com/in/mark-cuban-06a0755b/",
    listName: "VIP",
  },
];

export const template = {
  data: data,
  headers: headers,
  filename: "template.csv",
};
